import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['pagination', 'list', 'link'];
	static values = { baseUrl: String };

	connect() {
		this.setLinks();
	}

	setLinks() {
		this.paginationTarget.querySelectorAll('a[href]').forEach((link) => {
			link.dataset.action = 'click->admin--pagy#nextPage';
		});
	}

	_queryString() {
		return new URLSearchParams(new FormData(document.querySelector('#resources-search-form')));
	}

	async nextPage(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		const options = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
					.content,
			},
		};

		const query = this._queryString();
		query.set('page', new URL(evt.currentTarget.href).searchParams.get('page'));
		const url = `${this.baseUrlValue}?${query}`;
		const response = await fetch(url, options);
		const data = await response.json();

		this.listTarget.innerHTML = data.list;
		this.paginationTarget.outerHTML = data.pagination;
		this.setLinks();
	}
}
